import { render } from "./reportingBug.vue?vue&type=template&id=67656648&scoped=true"
import script from "./reportingBug.vue?vue&type=script&lang=js"
export * from "./reportingBug.vue?vue&type=script&lang=js"

import "./reportingBug.vue?vue&type=style&index=0&id=67656648&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67656648"]])

export default __exports__